module.exports = "https://www.niulinkcloud.com/_next/static/media/mobileBanner3.69c34177149e83a1887271716a7dcad8.png";